export default "__VITE_ASSET__d$CPm5HG__"